import TitleBar6 from './titleBar6';
export default TitleBar6;
